import { PageLoader } from '@seek/libs-shared';
import { useRouteLoaderData } from 'react-router';
import { CompanyProfilesPage } from '../../../paths';
import { CulturePage } from '../../pages/culture/CulturePage';
import type { CultureModel } from './cultureModel';

export function CulturePageContainer({
  trackPhotosPaginationClicked,
}: {
  trackPhotosPaginationClicked: ({
    pageNumber,
  }: {
    pageNumber: number;
  }) => void;
}): JSX.Element {
  const model = useRouteLoaderData(CompanyProfilesPage.Culture) as CultureModel;

  return model ? (
    <CulturePage
      model={model}
      trackPhotosPaginationClicked={trackPhotosPaginationClicked}
    />
  ) : (
    <PageLoader />
  );
}
